/**
 * Dormancy Store
 *
 * @author jaehyub.lee@emcast.com
 */
// states
const state = {
    userData: null,
    conditions: {
      termsAgree: false, // 약관 동의
      emailAuth: false, // 이메일 인증
      socialAccount: false, // 소셜 계정
      changePasswordRequest: false, // 비밀번호 변경 주기
      reIssueChangePassword: false, // 관리자에 의해 비밀 번호 변경
      responsibilityAuth: false, // 기존 직책코드 유지
      storeTransfer: false, // 매장 양도 이후 첫 로그인
    },
  };
  
  // getters
  const getters = {};
  
  // actions
  const actions = {
    SET_DORMANCY_USER_DETAIL({ commit }, value) {
      commit("MUTATION_USER_DATA", value);
    },
    SET_STATE_CATEGORY({ commit }, value) {
      commit("MUTATION_STATE_CATEGORY", value);
    },
  };
  
  // mutations === setters
  const mutations = {
    MUTATION_USER_DATA(state, value) {
      state.userData = value;
    },
    MUTATION_STATE_CATEGORY(state, value) {
      state.conditions[value.category] = value.value;
    },
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
  };
  